import styled from 'styled-components';

const InputError = styled.div`
    color: red;
    font-size: 13px;
    margin: 4px 0 0 0;
`;

export default InputError;
